import { FC } from 'react'
import {
    Card as StyledCard,
    IncidentMetrics,
    IncidentMetric,
    MetricHeader,
    MetricValue,
    MetricLabel,
    MetricDescription,
    ViewIncidentButton,
    IconWrapper,
    SectionHeader,
    SectionTitle,
    SectionHeaderContent,
} from '../../overview.styles'
import { Container } from './IncidentsOverview.styles'
import { useIncidentsOverview } from './useIncidentsOverview'
import InfoIconSvg from '@assets/images/info-icon.svg?react'
import { useRouting } from '@/core/hooks/useRouting'
import { MdrModule } from '@/core/modules/mdr/mdr.module'
import { CustomTooltip } from '@atbay/component-lib'
import { AccountModule } from '@/core/modules/account/account.module'

export const IncidentsOverview: FC = () => {
    const timeRange = MdrModule.getTimeRange()
    const { metrics, waitingIncidents, openDrawer } =
        useIncidentsOverview(timeRange)
    const { isMdrActive } = AccountModule.useStore()
    const { navigateTo, ROUTES } = useRouting()

    const handleMetricClick = (variant: string) => {
        if (variant === 'all') {
            MdrModule.getFilterModuleForTab('incidents').clearAllFilters()
        } else {
            MdrModule.getFilterModuleForTab('incidents').setFilter('status', [
                variant,
            ])
        }
        navigateTo({
            path: ROUTES.mdr.children.incidents.path,
            event: {
                name: 'SEM::incidents_overview_filters_clicked',
                params: {
                    filter: variant,
                    isMdrActive,
                },
            },
        })
    }

    return (
        <Container>
            <SectionHeader>
                <SectionHeaderContent>
                    <SectionTitle variant="m-semibold" component="h2">
                        Incidents Overview
                    </SectionTitle>
                    <CustomTooltip
                        title="A security alert or group of alerts that require additional response and customer awareness"
                        alwaysShowOnHover
                    >
                        <InfoIconSvg width={14} height={16} className="icon" />
                    </CustomTooltip>
                </SectionHeaderContent>
            </SectionHeader>
            <StyledCard>
                <IncidentMetrics>
                    {metrics.map((metric) => (
                        <IncidentMetric
                            key={metric.variant}
                            variant={metric.variant}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleMetricClick(metric.variant)}
                        >
                            <MetricHeader>
                                <MetricValue
                                    data-testid={`${metric.testId}-value`}
                                >
                                    {metric.value}
                                </MetricValue>
                                <IconWrapper>{metric.icon}</IconWrapper>
                            </MetricHeader>
                            <MetricLabel data-testid={`${metric.testId}-label`}>
                                {metric.label}
                            </MetricLabel>
                            <MetricDescription
                                data-testid={`${metric.testId}-description`}
                            >
                                {metric.description}
                            </MetricDescription>
                            {metric.action && waitingIncidents.length > 0 && (
                                <ViewIncidentButton
                                    data-testid={`${metric.testId}-view-incident-button`}
                                    variant="xs-regular"
                                    onClick={(e: any) => {
                                        e.stopPropagation()
                                        openDrawer(metric.action)
                                    }}
                                >
                                    {metric.action.icon && (
                                        <span className="icon">
                                            {metric.action.icon}
                                        </span>
                                    )}
                                    {metric.action.text}
                                </ViewIncidentButton>
                            )}
                        </IncidentMetric>
                    ))}
                </IncidentMetrics>
            </StyledCard>
        </Container>
    )
}
